const breadCrumb = "Diário Digital";

const routes = [
  {
    path: "/habilitar-uso-diario-digital",
    name: "habilitar-uso-diario-digital",
    meta: {
      allowedPermissions: ["instrumento_pedagogico_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/HabilitarUsoDiarioDigital/HabilitarUsoDiarioDigitalHome.vue"
      ),
  },
];

export default routes;
